<div class="ontario-row">
    <div class="ontario-column ontario-small-12">
        <input type="hidden" name="menuType" id="menuType" value="secure" />
        <h2 id="pageTitle">{{ 'bss.admin.confirmReq.title' | translate }}</h2>
        <hr>
    </div>
</div>

<div class="ontario-row">
    <div class="ontario-column ontario-small-12">

        <div *ngIf="appError" class="ontario-row" aria-live="polite" aria-atomic="true" id="pageLevelMessageId"
            #pageMsg>
            <div class="ontario-columns">
                <div class="ontario-alert ontario-alert--error ">
                    <div class="ontario-alert__header">
                        <div class="ontario-alert__header-icon">
                            <svg class="ontario-icon" alt="Error" aria-hidden="true" focusable="false"
                                sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <use href="#ontario-icon-alert-error"></use>
                            </svg>
                        </div>
                        <h2 class="ontario-alert__header-title ontario-h4">{{'bss.error' | translate}}</h2>
                    </div>
                    <div class="ontario-alert__body">
                        <p [innerHTML]="appErrorMessage | translate"></p>
                    </div>
                </div>
            </div>
        </div>

        <div class="ontario-table-container ontario-small-12 ontario-medium-12 ontario-large-12">
            <div class="ontario-table-div">
                <table tabindex="101" role="presentation">
                    <tr>
                        <td><b>{{ 'bss.admin.confirmReq.rowOne.title' | translate }}</b></td>
                        <td> {{ userRoleDetails.role.roleName }}</td>
                    </tr>
                    <tr>
                        <td><b>{{ 'bss.admin.confirmReq.rowTwo.title' | translate }}</b></td>
                        <td>{{ userRoleDetails.user.email }}</td>
                    </tr>
                    <tr>
                        <td><b>{{ 'bss.admin.confirmReq.rowThree.title' | translate }}</b></td>
                        <td>{{ userRoleDetails.user.guid }}</td>
                    </tr>
                    <tr>
                        <td><b>{{ 'bss.admin.confirmReq.rowFour.title' | translate }}</b></td>
                        <td>{{ this.operationDescription }}</td>
                    </tr>


                </table>

            </div>
        </div>
    </div>
</div>

<div *ngIf="operationKey==='assign'&& roleAssignmentEmail === 1" class="ontario-row">
    <div class="ontario-columns ontario-small-12">
        <div class="ontario-checkboxes">
            <div class="ontario-checkboxes__item">
                <input aria-describedby="agreeReqError" tabindex="102" class="ontario-checkboxes__input" id="agreeTerms"
                    name="agreeTerms" type="checkbox" [checked]="emailChecked" (change)="emailChecked = !emailChecked"
                    title="{{'bss.admin.confirmReq.checkbox.title' | translate }}" #checkbox>
                <label class="ontario-checkboxes__label" for="agreeTerms">
                    {{'bss.admin.confirmReq.checkbox' | translate }}
                </label>
            </div>
        </div>
    </div>
</div>
<div class="ontario-row">
    <div class="ontario-column ontario-small-12">
        {{ 'bss.admin.confirmReq.instruction' | translate}}
    </div>
</div>

<div class="ontario-row">
    <div class="ontario-column ontario-small-12">
        <button tabindex="105" (click)="onBack()" class="ontario-button ontario-button--secondary"
            title="{{ 'bss.admin.confirmReq.back.title' | translate }}">
            {{ 'bss.admin.confirmReq.back' | translate }}
        </button>
        <button tabindex="103" (click)="onConfirm()" class="ontario-button ontario-button--primary"
            title="{{ 'bss.admin.confirmReq.confirm.title' | translate }}">
            {{ 'bss.admin.confirmReq.confirm' | translate }}
        </button>
        <!-- <button tabindex="104" (click)="onCancel()" class="ontario-button ontario-button--secondary"
            title="{{ 'bss.admin.confirmReq.cancel.title' | translate }}">
            {{ 'bss.admin.confirmReq.cancel' | translate }}
        </button> -->
    </div>
</div>
<div class="ontario-row">
    <div class="ontario-column ontario-small-12">
        <button class="ontario-button ontario-button--secondary" tabindex="104"
            title="{{ 'bss.admin.selectUserAcc.newSearch.title' | translate }}" (click)="onNewSearch()">
            {{ 'bss.admin.selectUserAcc.newSearch' | translate }}
        </button>
    </div>

</div>
<dialog class="ontario-progress" #progressDialog>
    <app-progress></app-progress>
</dialog>